import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Info } from "lucide-react";

const Navbar = () => {
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();

  const updateCount = () => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const count = cart.reduce((sum, item) => sum + item.quantity, 0);
    setCartCount(count);
  };

  useEffect(() => {
    updateCount();
    window.addEventListener("cart-updated", updateCount);
    return () => window.removeEventListener("cart-updated", updateCount);
  }, []);

  return (
    <header className="sticky top-0 z-50 glass-nav shadow-sm select-none">
      <div className="max-w-lg mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo Brand */}
          <Link to="/" className="flex items-center gap-2 group">
            <img 
              src="/logo.png" 
              alt="KTZ Logo" 
              className="h-9 w-9 rounded-xl shadow-md border border-slate-100 group-hover:scale-105 transition-transform object-cover bg-white"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <span className="font-extrabold text-slate-800 tracking-tight text-base group-hover:text-blue-600 transition-colors">
              Kwality Tech Zone
            </span>
          </Link>

          {/* Navigation Links */}
          <nav className="flex items-center gap-4">
            <Link
              to="/about"
              className={`flex items-center gap-1.5 text-xs font-semibold tracking-wide uppercase transition-colors py-1.5 px-3 rounded-xl ${
                location.pathname === "/about"
                  ? "text-blue-600 bg-blue-50/80"
                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-100/80"
              }`}
            >
              <Info className="w-3.5 h-3.5" />
              <span>About</span>
            </Link>

            {/* Shopping Cart Indicator */}
            <Link
              to="/cart"
              className={`relative flex items-center gap-1.5 text-xs font-semibold tracking-wide uppercase transition-all py-1.5 px-3 rounded-xl ${
                location.pathname === "/cart"
                  ? "text-blue-600 bg-blue-50/80"
                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-100/80"
              }`}
            >
              <ShoppingBag className="w-3.5 h-3.5" />
              <span>Quote</span>
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white ring-2 ring-white animate-bounce">
                  {cartCount}
                </span>
              )}
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
